import Vue from "vue";
import { BACKEND_BASE_URL, SolutionDTO } from "../backend.types";
import { SolutionService } from "./solution.types";

export class SolutionServiceImpl implements SolutionService {
  async createSolution(solution: SolutionDTO): Promise<void> {
    await Vue.$axios.put(`${BACKEND_BASE_URL}/api/v1/creation-customer`, solution);
  }
}
